module.exports = __webpack_public_path__ + "components/page-header/static/surf-badge--light-be94ca609deb2377696c853062b05b78.svg";